import { parseISO } from 'date-fns';
import type { PostDataObject } from './service';

// TODO: this is not should call only post, because its post on feed, find better name
export type Post = {
  createdAt: Date;
  htmlContent?: string;
  id: string;
  status: string;
  textContent?: string;
  title?: string;
  todoDueDate?: Date;
};

export const createPostInContentObject = (data: PostDataObject): Post => ({
  createdAt: parseISO(data.created_at),
  htmlContent: data.html_content,
  id: data.id,
  status: data.status,
  textContent: data.text_content,
  title: data.title,
  todoDueDate: data.todo_due_date ? parseISO(data.todo_due_date) : undefined,
});
